import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, computed } from "vue";
// 子传父
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show", "change"],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    // 父传子
    const props = __props;
    const date = new Date();
    let currentDate = ref([date.getFullYear(), date.getMonth() + 1, date.getDate()]),
      currentTime = ref(["00", "00"]);
    // 日期组件数据格式化显示
    const formatter = (type, option) => {
      const arr = [{
        type: "year",
        text: "年"
      }, {
        type: "month",
        text: "月"
      }, {
        type: "day",
        text: "日"
      }, {
        type: "hour",
        text: "时"
      }, {
        type: "minute",
        text: "分"
      }, {
        type: "second",
        text: "second"
      }];
      arr.forEach(item => {
        if (item.type === type) {
          option.text += item.text;
        }
      });
      return option;
    };
    // 计算属性
    let open = computed({
      set(val) {
        return emits("update:show", val);
      },
      get() {
        return props.show;
      }
    });
    // 日期确认按钮操作
    const onConfirm = () => {
      emits("change", currentDate.value.join("-") + " " + currentTime.value.join(":"));
      open.value = false;
    };
    return (_ctx, _cache) => {
      const _component_van_date_picker = _resolveComponent("van-date-picker");
      const _component_van_time_picker = _resolveComponent("van-time-picker");
      const _component_van_picker_group = _resolveComponent("van-picker-group");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: _unref(open),
        "onUpdate:show": _cache[3] || (_cache[3] = $event => _isRef(open) ? open.value = $event : open = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker_group, {
          tabs: ['选择日期', '选择时间'],
          onConfirm: onConfirm,
          onCancel: _cache[2] || (_cache[2] = $event => _isRef(open) //@ts-ignore
          ? open.value = false : open = false)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_date_picker, {
            modelValue: _unref(currentDate),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentDate) ? currentDate.value = $event : currentDate = $event),
            formatter: formatter
          }, null, 8, ["modelValue"]), _createVNode(_component_van_time_picker, {
            modelValue: _unref(currentTime),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(currentTime) ? currentTime.value = $event : currentTime = $event),
            formatter: formatter
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"]);
    };
  }
});